import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-projects2",
  "use": "icon-projects2-usage",
  "viewBox": "0 0 16 19",
  "content": "<symbol viewBox=\"0 0 16 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-projects2\">\n<path fill=\"currentColor\" d=\"M0 0V0.730769V5.84615H2.90909V16.8077H8.72727V19H16V13.1538H8.72727V13.8846V15.3462H4.36364V9.5H8.72727V11.6923H16V5.84615H8.72727V6.57692V8.03846H4.36364V5.84615H7.27273V0H0ZM1.45455 1.46154H5.81818V4.38462H4.36364H2.90909H1.45455V1.46154ZM10.1818 7.30769H14.5455V10.2308H10.1818V7.30769ZM10.1818 14.6154H14.5455V17.5385H10.1818V14.6154Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol